import React from 'react';
import { Grid } from '@material-ui/core';
import { AxiosError } from 'axios';

import { PowerBIDashboard } from '../components/PowerBIDashboard';
import { DashboardStatus } from '../enums/DashboardStatus';
import { DashboardContext } from '../DashboardContext';
import { DashboardLoading } from '../components/DashboardLoading';
import { EmbedParamsModel, embedParamsModelInitial } from '../../../Models/EmbedParamsModel';
import { DashboardError } from '../components/DashboardError';
import { IErrorResponse } from '../../../shared/ErrorResponse';
import { ErrorHelper } from '../../../shared/ErrorHelper';
import { HomeContext } from '../../Home/HomeContext';
import DashboardService from '../../../Services/DashboardService';

export function DashboardGeneric() {
    const homeContext = React.useContext(HomeContext);

    const [dashboardStatus, setDashboardStatus] = React.useState<DashboardStatus>(DashboardStatus.DEFAULT);
    const [embedParams, setEmbedParamas] = React.useState<EmbedParamsModel>(embedParamsModelInitial);
    const [errorMessage, setErrorMessage] = React.useState<string>('');

    // Resetar o status quando o dashboard selecionado mudar
    React.useEffect(() => {
        if (homeContext.selectedDashboard) {
            setDashboardStatus(DashboardStatus.DEFAULT);
            setErrorMessage('');
        }
    }, [homeContext.selectedDashboard]);

    React.useEffect(() => {
        if (dashboardStatus === DashboardStatus.DEFAULT && homeContext.selectedDashboard) {
            setDashboardStatus(DashboardStatus.LOADING);

            const { workspaceId, reportId } = homeContext.selectedDashboard;

            DashboardService.getEmbedParams(workspaceId, reportId)
                .then((data: EmbedParamsModel) => {
                    setEmbedParamas(data);
                    
                    if (data.embedReport.pageName != '')
                        setDashboardStatus(DashboardStatus.DONE);
                    else {
                        setDashboardStatus(DashboardStatus.ERROR);
                        homeContext.showError('Não foi possível carregar o dashboard. Verifique se você tem acesso ao dashboard selecionado.');
                    }
                })
                .catch((error: AxiosError) => {
                    const errorResponse: IErrorResponse = ErrorHelper(error);
                    setErrorMessage(errorResponse.message);
                    setDashboardStatus(DashboardStatus.ERROR);
                });
        }
        
        // Se não há dashboard selecionado, mostra erro
        if (dashboardStatus === DashboardStatus.DEFAULT && !homeContext.selectedDashboard) {
            setDashboardStatus(DashboardStatus.ERROR);
            setErrorMessage('Nenhum dashboard foi selecionado.');
        }
    }, [dashboardStatus, homeContext.selectedDashboard]);    return (
        <DashboardContext.Provider value={{
            dashboardStatus, setDashboardStatus,
            embedParams, setEmbedParamas,
            errorMessage, setErrorMessage
        }}>
            <Grid
                container
                justify="center"
                alignItems="center">
                <Grid
                    container
                    direction="column"
                    alignItems="stretch"
                    justify="center">
                    <Grid item xs={12}>
                        {dashboardStatus === DashboardStatus.LOADING && <DashboardLoading />}
                        {dashboardStatus === DashboardStatus.DONE && <PowerBIDashboard />}
                        {dashboardStatus === DashboardStatus.ERROR && <DashboardError />}
                    </Grid>
                </Grid>
            </Grid>
        </DashboardContext.Provider>
    );
}